var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _circle, _circle2, _circle3, _path8, _path9, _circle4, _circle5, _circle6, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyPrize = function SvgImgEmptyPrize(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.445,
    y: 31.111,
    width: 45.556,
    height: 37.778,
    rx: 1,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23.334,
    width: 54.444,
    height: 7.778,
    rx: 1,
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.032 10.026c4.318-.47 10.444 5.504 13.188 8.8a.979.979 0 0 1 .224.628v2.88a1 1 0 0 1-1 1H22.497a.975.975 0 0 1-.958-.755c-1-4.42-1.697-12.096 2.493-12.553z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.032 10.026c4.318-.47 10.444 5.504 13.188 8.8a.979.979 0 0 1 .224.628v2.88a1 1 0 0 1-1 1H22.497a.975.975 0 0 1-.958-.755c-1-4.42-1.697-12.096 2.493-12.553z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.032 10.026c4.318-.47 10.444 5.504 13.188 8.8a.979.979 0 0 1 .224.628v2.88a1 1 0 0 1-1 1H22.497a.975.975 0 0 1-.958-.755c-1-4.42-1.697-12.096 2.493-12.553z",
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.412 10.026c-4.317-.47-10.443 5.504-13.187 8.8a.979.979 0 0 0-.225.628v2.88a1 1 0 0 0 1 1h13.948a.975.975 0 0 0 .958-.755c.999-4.42 1.697-12.096-2.494-12.553z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.412 10.026c-4.317-.47-10.443 5.504-13.187 8.8a.979.979 0 0 0-.225.628v2.88a1 1 0 0 0 1 1h13.948a.975.975 0 0 0 .958-.755c.999-4.42 1.697-12.096-2.494-12.553z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.412 10.026c-4.317-.47-10.443 5.504-13.187 8.8a.979.979 0 0 0-.225.628v2.88a1 1 0 0 0 1 1h13.948a.975.975 0 0 0 .958-.755c.999-4.42 1.697-12.096-2.494-12.553z",
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.333,
    y: 22.222,
    width: 7.778,
    height: 47.778,
    rx: 1,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.333,
    y: 22.222,
    width: 7.778,
    height: 47.778,
    rx: 1,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.333,
    y: 22.222,
    width: 7.778,
    height: 47.778,
    rx: 1,
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.444,
    y: 17.778,
    width: 5.556,
    height: 4.444,
    rx: 1,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.444,
    y: 17.778,
    width: 5.556,
    height: 4.444,
    rx: 1,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.444,
    y: 17.778,
    width: 5.556,
    height: 4.444,
    rx: 1,
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    d: "M36.844 20.044h-5.466m17.689 0H43.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 58,
    r: 9,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 58,
    r: 9,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 58,
    r: 9,
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.959 56.892v-.017a.321.321 0 0 0 0-.056v-.052a.471.471 0 0 0 0-.068v-.032a1.114 1.114 0 0 0-1.073-.815h-1.354c-.085 0-.12.038-.12.12v2c0 .081.035.116.12.116h1.523l.076-.014h.041l.065-.018.046-.018.059-.023.04-.02.056-.03.041-.026.05-.032.04-.03.048-.037.035-.033.04-.04.036-.039.038-.046.03-.041.031-.047.026-.044.027-.05.023-.046c0-.018.015-.038.024-.056l.017-.05.018-.055v-.05a.45.45 0 0 0 0-.061v-.167a.05.05 0 0 0 0-.02v-.044l-.003-.059z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.026 49.7A8.3 8.3 0 1 0 75.3 58a8.288 8.288 0 0 0-8.274-8.3zm.965 10.098h-1.5c-.085 0-.12.035-.12.12v2.172a.346.346 0 0 1-.345.348h-1.268a.345.345 0 0 1-.345-.348v-7.6a.345.345 0 0 1 .345-.345h3.274a2.824 2.824 0 1 1-.041 5.648v.006z",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 46,
    r: 9,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 46,
    r: 9,
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 46,
    r: 9,
    stroke: "#BDBDBD",
    strokeWidth: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 42.791c-.707-.632-1.51-1.097-2.588-1.24V40h-1.39v1.55c-1.604.204-2.587 1.194-2.587 2.649 0 2.887 4.576 2.421 4.576 3.698 0 .584-.467.882-1.557.882-.79 0-1.653-.238-2.42-.906L9.5 49.304c.73.716 1.976 1.086 2.923 1.17V52h1.39v-1.575c1.736-.286 2.634-1.347 2.634-2.72 0-2.886-4.575-2.385-4.575-3.65 0-.596.527-.834 1.317-.834.695 0 1.438.262 2.156.835L16.4 42.79z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyPrize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-prize.1c889cd43e18e06930bbe6888b4ca523.svg";